import { ExtendedDataProvider } from "@src/types";
import { useDataProvider, useNotify, useQueryWithStore } from "react-admin";
import React, { useEffect, useState } from "react";
import ReactJson from "@microlink/react-json-view";
import { Button, Dropdown, Space, Tooltip, Typography } from "antd";
import { DownOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import {getTagForStates} from "@src/components/Common/Tags";
import { spinnerElement } from "../../Common/utils";



const Declarations = (props: any) => {
    const [menuItems, setMenuItems] = useState<any[]>([]);
    const [version, setVersion] = useState<any>(0);
    const [schemaVersion, setSchemaVersion] = useState<any>(0);
    const [config, setConfig] = useState<any>({});
    const dataProvider: ExtendedDataProvider = useDataProvider();
    const notify = useNotify();

    const { service_item, resource } = props;

    const { data: versionsData, loaded: versionsLoaded } = useQueryWithStore({
        type: 'getAction',
        resource: resource,
        payload: { id: service_item.id, verb: 'declarations/versions' }
    });

    const { data: latestDeclarationData, loaded: latestDeclarationLoaded } = useQueryWithStore({
        type: 'getAction',
        resource: resource,
        payload: { id: service_item.id, verb: 'declarations/latest' }
    });

    useEffect(() => {
        if(latestDeclarationData){
            setVersion(latestDeclarationData.version != null ? latestDeclarationData.version : 0)
            setConfig(latestDeclarationData.version != null ? latestDeclarationData.declaration : {})
            setSchemaVersion(latestDeclarationData.version != null  ? latestDeclarationData.schema.version : 0)
        }
    }, [latestDeclarationData])


    useEffect(() => {
        if(versionsData){
            setMenuItems(
                Object.entries(versionsData).map(([key, value]: [string, any]) => ({
                    key: value.version,
                    label: <Space>{value.version} {getTagForStates(value.change_instance_state)}</Space>
                }))
            )

        }
    }, [versionsData])

    const handleVersionChange = (e: any) => {
        dataProvider.getAction(resource, { id: service_item.id, verb: 'declarations/versions/' + e.key.toString() })
            .then((response: any) => {
                setVersion(e.key)
                setConfig(response.data?.declaration)
                setSchemaVersion(response.data?.schema.version)
            })
            .catch((error: any) => { notify('Error fetching', 'error') })
    }

    if (!versionsData) {
        return spinnerElement;
    }

    return (
        <>
            Declaration Version: <Space />
            <Dropdown menu={{ items: menuItems, onClick: handleVersionChange }} trigger={['click']}>
                <a onClick={(e) => e.preventDefault()}>
                    <Button size="small"><Space><span style={{ fontWeight: 600, fontSize: 14 }}>{version}</span><DownOutlined /></Space></Button>
                </a>
            </Dropdown>
            <Typography.Text style={{ float: "right" }} type="secondary" >
                {
                    service_item.service.name} Schema Version: {
                    service_item.is_validated_minimum_schema ?
                        <Tooltip title="This declaration has been validated against the minimum version schema" color={"orange"} placement={"topRight"}>
                            {schemaVersion}{" "}
                            <ExclamationCircleFilled style={{ color: 'orange' }} />
                        </Tooltip>
                        :
                        <>{schemaVersion}</>
                }
            </Typography.Text>
            <ReactJson
                style={{ padding: '20px' }}
                src={config}
                displayDataTypes={false}
                name={null}
                displayArrayKey={false}
                displayObjectSize={false}
            />
        </>
    )
}
export default Declarations;
